import * as vp from 'vopay';
import { JSX, FunctionComponent } from 'react';
import { UtilButton } from 'UI';
import { useTranslation } from 'react-i18next';

const { Box, ElementContainer, TextField, Title } = vp;

type KeyValuePair = {
  display: string;
  value: JSX.Element;
  visible: boolean;
};

type FileUploadHeaderProps = {
  product: string;
  fileName: string;
  numberOfTransactions: number;
  backToPrev: () => void;
};

type FC = FunctionComponent<FileUploadHeaderProps>;

const FileUploadHeader: FC = (props: FileUploadHeaderProps) => {
  const { product, fileName, numberOfTransactions, backToPrev } = props;
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const FileUploadHeaderRows: KeyValuePair[] = [
    {
      display: 'Product',
      value: (
        <TextField
          name="Product"
          variant="background"
          placeholder={product}
          placeholderColor
          disabled
          onBlur={() => {}}
          onChange={() => {}}
        />
      ),
      visible: true,
    },
    {
      display: 'File Name',
      value: (
        <TextField
          name="fileName"
          variant="background"
          placeholder={fileName}
          placeholderColor
          disabled
          onBlur={() => {}}
          onChange={() => {}}
        />
      ),
      visible: true,
    },
    {
      display: 'Number of Contacts',
      value: (
        <TextField
          name="service"
          variant="background"
          placeholder={String(numberOfTransactions)}
          placeholderColor
          disabled
          onBlur={() => {}}
          onChange={() => {}}
        />
      ),
      visible: true,
    },
  ];

  return (
    <Box flx="col" gapSize="16px">
      <UtilButton
        iconLeft="chevron_left"
        size="large"
        onClick={() => {
          backToPrev();
        }}
      >
        {tGlobal('Buttons.back')}
      </UtilButton>
      <Box flx="col" gapSize="32px">
        <Box mb="md" jc="fs" ai="center" gap="common">
          <Title title="Bulk Contacts Upload" />
        </Box>
        <Box pb="lg" mb="md" gap="sm" jc="sb" width="100%" wrap="wrap">
          {FileUploadHeaderRows.filter(({ visible }) => visible).map(({ display, value }) => (
            <Box flx="col" width="49%" key={display}>
              <ElementContainer key={display} label={display} color="grey" required={false} input={value} />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default FileUploadHeader;
